export const DELETE_SURVEY = 'DELETE_SURVEY';
